//React
import React from "react";

//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as campaignAction from '../action/campaignAction';
import * as settingAction from '../action/settingAction';
import * as helpAction from '../action/helpAction';

import Button from '@material-ui/core/Button';
//Material-ui

//Add
import moment from 'moment';
import PartPageTitle from './PartPageTitle';
//Dialog
//Icon



class Comp extends React.Component {
  constructor(props) {
		super(props);

    this.state = {
      campaignCode: '',
      campaignCodeError: null,
      campaignCodeValid: false,
      campaignId: null,
      campaignName: '',
      campaignDiscription: '',
      campaignDateStart: null,
      campaignDateEnd: null,
      campaignLimit: 0,
      campaignValid: null,
      errorComment: '',
    }
	}

  componentDidMount() {
    document.title = 'キャンペーンの申し込み - パートナーズ';
  }

  _campaignCodeEdit(value) {
  	value = value.replace(/[ 　]/g, '');

    value = value.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function(s) {
      return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
    });
    this.setState({ campaignCode: value});

    let errorComment;

    if (value.length === 0) {
  		errorComment = 'キャンペーンコード入力してください';
  	}
    else if (value.match(/^[a-zA-Z0-9]+$/) == null) {
  		errorComment = '入力できない文字があります';
  	}
    else if (value.length < 6 || value.length > 10) {
  		errorComment = '6〜10文字で入力してください';
  	}

  	if (errorComment) {
  		this.setState({campaignCodeError: errorComment, campaignCodeValid:false});
  	}
  	else {
      this.setState({campaignCodeError: null, campaignCodeValid:true});
    }
  }

  _campaignCodeCheck() {
    this.props.campaignCodeCheck(this.state.campaignCode, (data) => {
      this.setState({
        campaignId: data.campaign_id,
        campaignName: data.campaign_name,
        campaignDiscription: data.campaign_discription,
        campaignDateStart: data.campaign_date_start,
        campaignDateEnd: data.campaign_date_end,
        campaignLimit: data.campaign_limit,
        campaignValid:  data.campaign_valid,
        campaignValidComment:  data.campaign_valid_comment,
      });
    });
  }

  _campaignSubmit() {
    this.props.campaignSubmit(this.state.campaignCode, (data) => {
      if (this.props.my.profile.userdata_sex === 'men') {
        this.props.history.push('/');
      }
      if (this.props.my.profile.userdata_sex === 'women') {
        this.props.history.push('/my/paymentTicketSender/');
      }
      this.setState({
        campaignCode: '',
        campaignId: null,
      });
    });
  }

  render() {
    return (
      <div style={{maxWidth:'600px', margin:'auto'}}>
        <PartPageTitle
          title={'キャンペーンコード'}
          onback={ '/' }
        />
        <div style={{maxWidth:'400px', margin:'auto'}}>
        {
          (!this.state.campaignId) ? (
            <div>
              <div style={{padding:'10px'}}>
                <div>キャンペーンの時に配布しているキャンペーンコードを入力いただくと有料サービスや応援チケットなどが貰えます。</div>
                <div style={{padding:'10px'}}>
                  <div style={{color:'#666'}}>英数6～10文字</div>
                  <input
                    type="text"
                    value={ this.state.campaignCode }
                    style={{fontSize:'1.6em'}}
                    className="input_blue round12"
                    onChange={ (e) => this._campaignCodeEdit(e.target.value) }
                  />
                  <div style={{color:'red'}}>{this.state.campaignCodeError}</div>
                </div>

              </div>

              <div align='center' style={{padding:'10px'}}>
                <Button
                  variant="contained"
                  color="primary"
                  style={{minWidth:'240px'}}
                  onClick={ () => this._campaignCodeCheck() }
                  disabled={ (this.state.campaignCodeValid === true) ? false : true }
                >
                  <div style={{fontSize:'1.4em'}}>送信する</div>
                </Button>
              </div>
            </div>
          ) : (
            <div>
              <h2 style={{padding:'10px'}}>
                {this.state.campaignName}
              </h2>
              <div style={{padding:'10px'}}>
                <h3 style={{padding:'5px'}}>
                  内容
                </h3>
                <div style={{whiteSpace: 'pre-line',color:'#333'}}>
                  {this.state.campaignDiscription}
                </div>
              </div>

              <div style={{padding:'10px'}}>
                <h3 style={{padding:'5px'}}>
                  応募期間
                </h3>
                <div style={{whiteSpace: 'pre-line',color:'#333'}}>
                  { moment(this.state.campaignDateStart).format('YYYY年MM月DD日') } 〜 { moment(this.state.campaignDateEnd).format('YYYY年MM月DD日') }
                </div>
              </div>

              <div style={{padding:'10px'}}>
                <h3 style={{padding:'5px'}}>
                  応募人数
                </h3>
                <div style={{color:'#333'}}>
                  { (this.state.campaignLimit === 0) ? '無制限' : this.state.campaignLimit + '人' }
                </div>
              </div>

              {
                (this.state.campaignValid === false) && (
                  <div style={{padding:'10px', color:'red'}}>
                    {this.state.campaignValidComment}
                  </div>
                )
              }

              <div align='center' style={{padding:'10px'}}>
                <Button
                  variant="outlined"
                  color="primary"
                  style={{fontSize:'1em'}}
                  onClick={ () => this.setState({
                    campaignId: null,
                    campaignName: '',
                    campaignDiscription: '',
                    campaignDateStart: null,
                    campaignDateEnd: null,
                    campaignLimit: 0,
                    campaignValid: null,
                    errorComment: '',
                  })}
                >
                  キャンセル
                </Button>
                &nbsp;
                {
                  (this.state.campaignValid === true) && (
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={ () => this._campaignSubmit() }
                      disabled={ (this.state.campaignCodeValid === true) ? false : true }
                    >
                      <div style={{fontSize:'1.2em'}}>応募する</div>
                    </Button>
                  )
                }
              </div>
            </div>
          )
        }
        </div>
      </div>
    )

  }
}


const mapStateToProps = (state) => {
	return {
    my: state.my,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
    ...campaignAction,
    ...settingAction,
    ...helpAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
